// extracted by mini-css-extract-plugin
module.exports = {"group":"QuickLinksGroup_group__Y4H8m","title":"QuickLinksGroup_title__NkOqR","categoryTitle":"QuickLinksGroup_categoryTitle__m3pFZ","links":"QuickLinksGroup_links__vNxF_"};